import { Component, Input, OnInit } from '@angular/core';
import { SliderModel } from '../../models/slider.model';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss'],
})
export class SliderComponent implements OnInit {
  @Input() slider: SliderModel;

  constructor() {}

  ngOnInit() {}
}
